<template>
  <div>
        <!-- bloki informujace o wczytywaniu danych -->
        <div class="bi-on-top bi-fade hidden" ref="spinner">
            <div>
                <i class="fas fa-spinner fa-spin bi-vertical-align-middle bi-color-blue1"></i>
            </div>
        </div>

        <div class="bi-on-top bi-fade hidden" ref="error">
            <div>
                Load data error :(
            </div>
        </div>

        <div class="bi-on-top bi-fade hidden" ref="blocker">

        </div>
    </div>
</template>

<script>
export default {
    name: 'BusyIndicator',
    data: function(){
        return {

        }
    },
    methods: {
        showSpinner: function(){
            $(this.$refs['spinner']).removeClass('hidden');
            $(this.$refs['error']).addClass('hidden');
            $(this.$refs['blocker']).addClass('hidden');
        },

        showError: function(){
            $(this.$refs['spinner']).addClass('hidden');
            $(this.$refs['error']).removeClass('hidden');
            $(this.$refs['blocker']).addClass('hidden');
        },

        hideAll: function(){
            $(this.$refs['spinner']).addClass('hidden');
            $(this.$refs['error']).addClass('hidden');
            $(this.$refs['blocker']).addClass('hidden');
        }
    }
};
</script>

<style>
.bi-on-top {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  /*border:1px solid red;*/
  /*display:flex;*/
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flexbox;
  display: -o-flex;
  display: flex;
  /* Direction defaults to 'row', so not really necessary to specify */
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  -o-flex-direction: row;
  flex-direction: row;
  -ms-flex-align: center;
}

.bi-on-top div {
  /*border:1px solid green;*/
  margin: auto auto auto auto;
  display: block;
  font-weight: bold;
  font-size: 24px;
}

.bi-fade {
  background-color: rgba(255, 255, 255, 0.5);
}

.bi-vertical-align-middle {
  vertical-align: middle;
}

.bi-color-blue1 {
  color: #3c8dbc;
}
</style>



// WEBPACK FOOTER //
// src/components/BusyIndicator.vue